export default __webpack_public_path__ + "static/media/PC-04.3257afdd.jpg";